import React from "react";
import { disregardOutcomes, disregardReasons } from "_constants";
import classnames from "classnames";
import sortBy from "lodash/sortBy";
import PropTypes from "prop-types";

import SubmitButton from "components/SubmitButton";
import Translate from "utils/translate";

import Modal, { ModalBody, ModalFooter, ModalHeader } from "../Modal";
import TitledDropdown from "../TitledDropdown";

import styles from "./DisregardModal.css";

const { t } = new Translate("DisregardModal");

export default class DisregardModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisregarding: false,
      isInvalid: false,
      outcome: props.outcome,
      reason: props.reason,
      feedback: props.feedback,
    };

    this.handleDisregard = this.handleDisregard.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleFeedbackChange = this.handleFeedbackChange.bind(this);
    this.isFeedbackValid = this.isFeedbackValid.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isDisregarding: false,
      isInvalid: false,
      outcome: nextProps.outcome,
      reason: nextProps.reason,
      feedback: nextProps.feedback,
    });
  }

  handleChange(key, val) {
    this.setState({ [key]: val });
  }

  handleFeedbackChange(textarea) {
    this.setState({ feedback: textarea.target.value });
  }

  handleDisregard() {
    if (this.isFeedbackValid()) {
      this.setState({ isDisregarding: true });
      this.props.onDisregard({
        feedback: this.state.feedback,
        outcome: this.state.outcome || "unknown",
        reason: this.state.reason || "unknown",
      });
    } else {
      this.setState({ isInvalid: true });
    }
  }

  isFeedbackValid() {
    const { feedback, outcome, reason } = this.state;

    return (reason !== "other_reason" && outcome !== "other_outcome") || feedback;
  }

  render() {
    const { isLoading, isOpen, onClose } = this.props;
    const { isDisregarding, isInvalid, outcome, reason } = this.state;

    const outComeValueExtractor = (o) => t(`disregard_outcomes.${o}`);
    const reasonValueExtractor = (r) => t(`disregard_reasons.${r}`);

    return (
      <div>
        <Modal isOpen={isOpen} onClose={isDisregarding ? null : onClose}>
          <ModalHeader onClose={isDisregarding ? null : onClose}>{t("header")}</ModalHeader>
          <ModalBody>
            <div className={styles.fields}>
              <TitledDropdown
                onSelect={(val) => this.handleChange("outcome", val)}
                selectedValue={outcome}
                title={t("outcome")}
                valueExtractor={outComeValueExtractor}
                values={sortBy(disregardOutcomes, outComeValueExtractor)}
                isEdit
                isUnselectable
              />
              <TitledDropdown
                onSelect={(val) => this.handleChange("reason", val)}
                selectedValue={reason}
                title={t("reason")}
                valueExtractor={reasonValueExtractor}
                values={sortBy(disregardReasons, reasonValueExtractor)}
                isEdit
                isUnselectable
              />
            </div>
            <div
              className={classnames(styles.feedback, {
                [styles.invalid]: isInvalid && !this.isFeedbackValid(),
              })}
            >
              <textarea
                onChange={this.handleFeedbackChange}
                placeholder={t("feedbackPlaceholder")}
              />
              <p>{t("feedbackInfo")}</p>
            </div>
          </ModalBody>
          <ModalFooter>
            <SubmitButton
              isSubmitting={isLoading}
              onSubmit={this.handleDisregard}
              submitLabel={t("disregard")}
              submittingLabel={t("disregarding")}
            />
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

DisregardModal.propTypes = {
  onClose: PropTypes.func,
  onDisregard: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  outcome: PropTypes.string,
  reason: PropTypes.string,
  feedback: PropTypes.string,
};
